import { PaymentReconciliationPage } from "@/components/payments/PaymentReconciliationPage";

export default function Payments() {
  return <PaymentReconciliationPage />;
}
